import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationDismissedDataSelector } from "./recommendationsDataGridDimissedDataSelector";
import { recommendationAppliedProvidersSelector } from "../../filters/recommendationAppliedProvidersSelector";
import { recommendationAppliedTypesSelector } from "../../filters/recommendationAppliedTypesSelector";
import { recommendationAppliedAccountsSelector } from "../../filters/recommendationAppliedAccountsSelector";
import { recommendationAppliedTagsSetSelector } from "../../filters/recommendationAppliedTagsSetSelector";
import { recommendationsDataByFiltersFilterCombiner } from "../../../combiners/off-hours/recommendationsDataByFiltersFilterCombiner";
import { RecommendationDataType } from "../../../../../components/pages/recommendations/components/off-hours-recommendations/utils/types/types";

export const recommendationsDataGrdDismissedFilteredDataSelector =
  createDraftSafeSelector(
    [
      recommendationDismissedDataSelector,
      recommendationAppliedProvidersSelector,
      recommendationAppliedTypesSelector,
      recommendationAppliedAccountsSelector,
      recommendationAppliedTagsSetSelector,
    ],
    (data, providers, types, accounts, tags): RecommendationDataType[] => {
      return recommendationsDataByFiltersFilterCombiner(
        data,
        providers,
        types,
        accounts,
        tags,
      );
    },
  );
